import { makeStyles } from '@material-ui/core/styles'

const drawerWidth = 224

export const useStyles = makeStyles(theme => ({
  layoutContainer: {
    height: '100vh'
  },
  root: {
    display: 'flex'
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
    backgroundColor: '#FFFFFF',
    boxShadow: '0 5px 25px 0 rgba(32,34,53,0.15)',
    color: '#fff'
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto'
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    height: '100%'
  }
}))
